import type { ReactNode } from 'react';

export function SectionEyebrow({
  children,
  start,
  className = '',
}: {
  children: ReactNode;
  start?: boolean;
  className?: string;
}) {
  return (
    <div className={`section-eyebrow ${start ? 'is-start' : ''} ${className}`}>
      <span>{children}</span>
    </div>
  );
}
